// extracted by mini-css-extract-plugin
export default {"root":"Editor_root__bmqPG","textArea":"Editor_textArea__Vm3xz","control":"Editor_control__K9Doh","controlButton":"Editor_controlButton__pckP7"};